<template>
  <div>
    <Header v-if="logged_in" />
    <Breadcrumbs v-if="logged_in" />
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
    <Footer v-if="logged_in" />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import Breadcrumbs from './components/Breadcrumbs.vue';
import { DateTime } from "luxon";
import {mapGetters} from "vuex";

export default {
  name: 'App',
  data() {
    return {
      logged_in: false,
    }
  },
  components: {
    Header,
    Footer,
    Breadcrumbs,
  },
  mounted() {
    this.checkLoggedIn();
  },
  computed: {
    ...mapGetters(['getUsers']),
  },
  methods: {
    checkLoggedIn() {
      // Early return op basis van ruwe browser path om timing issues met route resolving te voorkomen
      const rawPath = (window.location.pathname || '').replace(/\/$/, '');
      const publicPathSet = new Set(['/aanmelden','/wachtwoord-vergeten','/wachtwoord-resetten']);
      if (publicPathSet.has(rawPath)) {
        // Zorg dat app in "niet ingelogd" modus blijft maar geen redirect uitvoert
        this.logged_in = false;
        return;
      }

      // Publieke routes (op basis van route name)
      const publicRouteNames = new Set(['LoginOverlay','ForgotPassword','ResetPassword']);
      // Oud pad fallback (voor zekerheid bij naam mismatch)
      const publicPaths = ['/aanmelden','/wachtwoord-vergeten','/wachtwoord-resetten'];

      const isPublicRoute = publicRouteNames.has(this.$route.name) || publicPaths.includes(this.$route.path) || publicPaths.includes(this.$route.path.replace(/\/$/, ''));

      // Nieuwe keys (Bearer token)
      const token = localStorage.getItem('hopstats-auth-token');
      const tokenType = localStorage.getItem('hopstats-auth-type');
      const expiresAt = localStorage.getItem('hopstats-auth-expires');
      const appKeyName = localStorage.getItem('hopstats-app-key-name');
      const appKeyValue = localStorage.getItem('hopstats-app-key-value');
      const storedRole = localStorage.getItem('hopstats-user-role');

      let useNew = false;
      if (token && tokenType) {
        let notExpired = true;
        if (expiresAt) {
            const exp = DateTime.fromSQL(expiresAt, { zone: 'utc' });
            if (exp.isValid && DateTime.now() > exp) {
              notExpired = false;
            }
        }
        if (notExpired) {
          const headers = { 'Authorization': `${tokenType} ${token}` };
          if (appKeyName && appKeyValue) {
            headers[appKeyName] = appKeyValue;
          }
          this.$store.state.api_headers = headers;
          this.$store.commit('SET_USER_ROLE', storedRole || 'user');
          this.logged_in = true;
          useNew = true;
        }
      }

      if (!useNew) {
        // Fallback naar oude keys (legacy)
        if (localStorage.getItem('hopstats-api-key-expiry') !== null && localStorage.getItem('hopstats-api-key') !== null && localStorage.getItem('hopstats-api-key-name') !== null) {
          let expiry = localStorage.getItem('hopstats-api-key-expiry');
          let now = DateTime.now().toISO();
          if (now > expiry) {
            this.logOut();
          } else {
            let api_headers = {};
            api_headers[localStorage.getItem('hopstats-api-key-name')] = localStorage.getItem('hopstats-api-key');
            this.$store.state.api_headers = api_headers;
            this.$store.commit('SET_USER_ROLE', storedRole || 'user');
            this.logged_in = true;
          }
        } else if(!this.logged_in) {
          this.logged_in = false;
          if (!isPublicRoute) {
            this.$router.push('/aanmelden');
          }
        }
      }
    },
    logOut()
    {
        // Nieuwe keys verwijderen
        ['hopstats-auth-token','hopstats-auth-type','hopstats-auth-expires','hopstats-app-key-name','hopstats-app-key-value','hopstats-user-role','hopstats-stay-logged-in']
          .forEach(k => localStorage.removeItem(k));
        // Oude keys verwijderen
        localStorage.removeItem('hopstats-api-key-name');
        localStorage.removeItem('hopstats-api-key');
        localStorage.removeItem('hopstats-api-key-expiry');
        window.location.reload();
    },
    checkUserValidationStatus()
    {
      this.$store.state.uservalidations['to-review'] = 0;
      this.$store.state.uservalidations['accepted'] = 0;
      this.$store.state.uservalidations['rejected'] = 0;

      this.$store.dispatch('getUsers').then(() => {
        this.getUsers.forEach(user => {
          this.$store.state.uservalidations[user.validation_status]++;
        });
      })
    }
  },
}
</script>